import useMainStore from "../../../stores/mainStore";
import { toast } from "react-toastify";
import { supabase } from "../../../context/useSupabaseContext";

export default async function uploadTextFile(
    noteID: string,
    noteContents: string
): Promise<boolean> {
    if (!noteID || noteContents === undefined || noteContents === null) return false;

    useMainStore.getState().syncFunctions.addIsUploading("noteUpload");

    try {
        const { data: { user } } = await supabase.auth.getUser();

        if (!user) {
            console.error("No authenticated user found");
            useMainStore.getState().syncFunctions.removeIsUploading("noteUpload");
            return false;
        }

        const userId = user.id;
        const bucket = supabase.storage.from("user-data");
        const folderName = userId;
        if (!folderName) {
            throw new Error("Folder name not found");
        }

        const { error } = await bucket.upload(
            `${folderName}/${noteID}`,
            noteContents,
            {
                upsert: true,
            }
        );

        if (error) {
            throw error;
        }

        console.log("Uploaded note to Supabase: ", noteID);

        useMainStore.getState().syncFunctions.removeIsUploading("noteUpload");
        useMainStore.getState().syncFunctions.removeChangesMade("noteChanged");

        return true;
    } catch (error) {
        console.error("Error uploading note:", error);
        toast.error("Failed to upload note");
        useMainStore.getState().syncFunctions.removeIsUploading("noteUpload");
        return false;
    }
}
